import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function MenuSection() {
  const [activeTab, setActiveTab] = useState('menu');
  const tabs = [{
    id: 'menu',
    label: 'Menú del Día'
  }, {
    id: 'carnes',
    label: 'Carta de Carnes'
  }, {
    id: 'vinos',
    label: 'Vinos y Postres'
  }];
  return <section id="carta" className="py-24 bg-laura-cream text-laura-dark" data-id="element-142">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-laura-olive text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-145">
            La Carta
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-playfair text-laura-wood mb-8" data-id="element-146">
            Menú del día y especialidades
          </motion.h2>
        </div>

        <div className="flex flex-col sm:flex-row justify-center border-b border-laura-wood/20 mb-12" data-id="element-147">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`py-4 px-8 text-lg uppercase tracking-wider transition-colors duration-300 ${activeTab === tab.id ? 'text-laura-wood border-b-2 border-laura-amber font-bold' : 'text-laura-wood/60 border-b-2 border-transparent hover:text-laura-wood'}`} data-id="element-148">
              {tab.label}
            </button>)}
        </div>

        <div className="min-h-[400px]" data-id="element-149">
          <AnimatePresence mode="wait" data-id="element-150">
            {activeTab === 'menu' && <motion.div key="menu" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} className="bg-white p-8 md:p-12 rounded-lg shadow-xl border border-laura-beige" data-id="element-151">
                <div className="text-center mb-10" data-id="element-152">
                  <h3 className="text-3xl font-playfair text-laura-wood mb-2" data-id="element-153">
                    Menú del Día
                  </h3>
                  <p className="text-2xl text-laura-amber font-bold" data-id="element-154">15€</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-155">
                  <div data-id="element-156">
                    <h4 className="text-xl font-playfair text-laura-olive border-b border-laura-amber/30 pb-2 mb-4" data-id="element-157">
                      Primeros
                    </h4>
                    <ul className="space-y-3 text-laura-wood/80" data-id="element-158">
                      <li data-id="element-159">Sopa castellana</li>
                      <li data-id="element-160">Ensalada de la huerta</li>
                      <li data-id="element-161">Croquetas caseras de jamón</li>
                    </ul>
                  </div>
                  <div data-id="element-162">
                    <h4 className="text-xl font-playfair text-laura-olive border-b border-laura-amber/30 pb-2 mb-4" data-id="element-163">
                      Segundos
                    </h4>
                    <ul className="space-y-3 text-laura-wood/80" data-id="element-164">
                      <li data-id="element-165">Secreto ibérico a la brasa</li>
                      <li data-id="element-166">Merluza al horno con patatas</li>
                      <li data-id="element-167">Pollo asado al estilo tradicional</li>
                      <li data-id="element-168">Cocido madrileño</li>
                    </ul>
                  </div>
                </div>

                <div className="mt-10 text-center" data-id="element-169">
                  <h4 className="text-xl font-playfair text-laura-olive mb-4" data-id="element-170">
                    Postre
                  </h4>
                  <p className="text-laura-wood/80" data-id="element-171">
                    Tarta casera del día / Fruta de temporada
                  </p>
                  <p className="mt-6 text-sm font-bold text-laura-wood uppercase tracking-wider" data-id="element-172">
                    Incluye: Pan, bebida y café
                  </p>
                  <p className="mt-8 text-sm italic text-laura-wood/60" data-id="element-173">
                    Menú sujeto a disponibilidad. Consulta el menú del día
                    llamando al restaurante. Opciones aptas para celíacos
                    disponibles.
                  </p>
                </div>
              </motion.div>}

            {activeTab === 'carnes' && <motion.div key="carnes" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} className="bg-white p-8 md:p-12 rounded-lg shadow-xl border border-laura-beige" data-id="element-174">
                <div className="space-y-12" data-id="element-175">
                  <div data-id="element-176">
                    <h3 className="text-2xl font-playfair text-laura-wood border-b-2 border-laura-amber pb-3 mb-6 inline-block" data-id="element-177">
                      Carnes a la Brasa
                    </h3>
                    <ul className="space-y-6" data-id="element-178">
                      <li data-id="element-179">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-180">
                          Chuletón de ternera (500g)
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-181">
                          Nuestra especialidad, asado a la parrilla con sal en
                          escamas.
                        </p>
                      </li>
                      <li data-id="element-182">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-183">
                          Secreto ibérico
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-184">
                          Corte jugoso y sabroso, cocinado lentamente a la
                          brasa.
                        </p>
                      </li>
                      <li data-id="element-185">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-186">
                          Costillas de cordero
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-187">
                          Tiernas y crujientes, acompañadas de patatas panadera.
                        </p>
                      </li>
                      <li data-id="element-188">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-189">
                          Entrecot a la brasa
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-190">
                          Corte clásico de ternera, tierno y lleno de sabor.
                        </p>
                      </li>
                      <li data-id="element-191">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-192">
                          Hamburguesa de buey con pan rústico
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-193">
                          Carne de buey de primera calidad, servida en pan
                          artesanal.
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div data-id="element-194">
                    <h3 className="text-2xl font-playfair text-laura-wood border-b-2 border-laura-amber pb-3 mb-6 inline-block" data-id="element-195">
                      Especialidades
                    </h3>
                    <ul className="space-y-6" data-id="element-196">
                      <li data-id="element-197">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-198">
                          Cochinillo asado
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-199">
                          Asado en horno de leña, piel crujiente y carne que se
                          deshace.
                        </p>
                      </li>
                      <li data-id="element-200">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-201">
                          Lechazo al horno de leña
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-202">
                          Cuarto de lechazo asado tradicionalmente con agua y
                          sal.
                        </p>
                      </li>
                      <li data-id="element-203">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-204">
                          Paletilla de cordero
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-205">
                          Asada a fuego lento, jugosa y aromática.
                        </p>
                      </li>
                      <li data-id="element-206">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-207">
                          Pulpo asado
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-208">
                          Tierno por dentro y crujiente por fuera, con pimentón
                          de la Vera.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="mt-10 pt-6 border-t border-laura-beige text-center" data-id="element-209">
                  <p className="text-sm italic text-laura-wood/60" data-id="element-210">
                    Consulta precios en el restaurante. Opciones aptas para
                    celíacos disponibles.
                  </p>
                </div>
              </motion.div>}

            {activeTab === 'vinos' && <motion.div key="vinos" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} className="bg-white p-8 md:p-12 rounded-lg shadow-xl border border-laura-beige" data-id="element-211">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-212">
                  <div data-id="element-213">
                    <h3 className="text-2xl font-playfair text-laura-wood border-b-2 border-laura-amber pb-3 mb-6 inline-block" data-id="element-214">
                      Vinos de la Casa
                    </h3>
                    <ul className="space-y-6" data-id="element-215">
                      <li data-id="element-216">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-217">
                          Vinos de Madrid y Chinchón
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-218">
                          Selección local de Villaconejos y alrededores.
                        </p>
                      </li>
                      <li data-id="element-219">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-220">
                          Tinto Ribera del Duero y Rioja
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-221">
                          Ideal para acompañar nuestras carnes rojas.
                        </p>
                      </li>
                      <li data-id="element-222">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-223">
                          Vinos Cava Submarina
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-224">
                          Vinos experimentales envejecidos bajo el mar.
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div data-id="element-225">
                    <h3 className="text-2xl font-playfair text-laura-wood border-b-2 border-laura-amber pb-3 mb-6 inline-block" data-id="element-226">
                      Postres Caseros
                    </h3>
                    <ul className="space-y-6" data-id="element-227">
                      <li data-id="element-228">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-229">
                          Tarta de queso artesanal
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-230">
                          Nuestra receta secreta, cremosa y deliciosa.
                        </p>
                      </li>
                      <li data-id="element-231">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-232">
                          Crema catalana
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-233">
                          Con su característica capa de azúcar quemado.
                        </p>
                      </li>
                      <li data-id="element-234">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-235">
                          Tarta de la abuela
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-236">
                          Galleta, chocolate y natillas, como manda la
                          tradición.
                        </p>
                      </li>
                      <li data-id="element-237">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-238">
                          Flan casero y Natillas
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-239">
                          Los clásicos de siempre, hechos con huevos de corral.
                        </p>
                      </li>
                      <li data-id="element-240">
                        <h4 className="text-lg font-bold text-laura-dark" data-id="element-241">
                          Pudding casero
                        </h4>
                        <p className="text-laura-wood/70 mt-1" data-id="element-242">
                          Suave y esponjoso, elaborado en nuestra cocina.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="mt-10 pt-6 border-t border-laura-beige text-center" data-id="element-243">
                  <p className="text-sm italic text-laura-wood/60" data-id="element-244">
                    Consulta precios en el restaurante
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}